import {
  Button as AntButton,
  Button,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Divider,
  Flex,
  Layout,
  Modal,
  Radio,
  Row,
  Space
} from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { Detail } from "components/elements";
import {
  DatePicker,
  Input,
  Select,
  Switch
} from "components/form";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "utils/formatter";
import { formatBankAccountNo } from "utils/formatter/formatCommon";
import employmentInfoSchema, { initialValues as initialValue } from "../schemas/employeeEmploymentInfoSchema";
import employeeEmploymentModalSchema, { initialValues as INITIAL_VALUES } from "../schemas/employeeEmploymentModalSchema";
import styles from "../styles/EmployeeForm.module.css";
import i18n from "i18n";


const { Content, Footer } = Layout;

const EmployeeDetailsCard = ({ title, details, comparisonDetails = [] }) => {
  const { t, i18n } = useTranslation();
  // console.log("comparisonDetails", comparisonDetails);
  // console.log("details", details);




  const groupDetailsByType = (details) => {
    return details.reduce((groups, detail) => {
      const { type } = detail;
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(detail);
      return groups;
    }, {});
  };


  const filterChangedDetails = (details, comparisonDetails) => {
    const comparisonMap = comparisonDetails.reduce((map, detail) => {
      map[detail.label] = detail.value;
      return map;
    }, {});

    return details.filter((detail) => {
      const comparisonValue = comparisonMap[detail.label];

      return (
        detail.value !== comparisonValue &&
        comparisonValue !== undefined &&
        comparisonValue !== null &&
        comparisonValue !== ""
      );
    });
  };

  const filteredDetails = filterChangedDetails(details, comparisonDetails);

  const groupedDetails = groupDetailsByType(filteredDetails);

  const filteredGroups = Object.keys(groupedDetails).filter((type) => {
    return groupedDetails[type].some(
      (detail) =>
        detail.value !== undefined &&
        detail.value !== null &&
        detail.value !== "" &&
        (!Array.isArray(detail.value) ||
          detail.value.some((v) => v !== null && v !== undefined && v !== ""))
    );
  });

  const formatDetailValue = (detail, i18n) => {
    switch (detail.label) {
      case "หัวหน้างาน":
        return detail?.value?.[0]?.fullName ?? "-";
      case "วิธีการชำระเงิน":
        if (detail.value === "BANK") return i18n.language === "en" ? "BANK" : "ธนาคาร";
        if (detail.value === "CASH") return i18n.language === "en" ? "CASH" : "เงินสด";
        if (detail.value === "PROMPTPAY") return i18n.language === "en" ? "PROMPTPAY" : "พร้อมเพย์";
        return "-";
      case "DONTRECORD":
        return i18n.language === "en" ? "DONTRECORD" : "ไม่บันทึก";
      case "RECORD":
        return i18n.language === "en" ? "RECORD" : "บันทึก";

      case "เลขที่บัญชีธนาคาร":
      case "Bank Account No":
        return formatBankAccountNo(detail?.value, true) ?? "-";
      default:
        return detail?.value ?? "-";
    }
  };

  return (
    <Card style={{ height: "100%", width: "100%", border: "0.01px solid" }}>
      <h3>{title}</h3>
      {filteredGroups.map((type) => (
        <div key={type}>
          <h4>{t(`movement.label.${type.toLowerCase()}`)}</h4>
          {groupedDetails[type].map((detail, index) => (
            <Detail
              key={index}
              open={detail.open}
              label={detail.label}
              value={formatDetailValue(detail, i18n)}
            />
          ))}
        </div>
      ))}
    </Card>
  );
};
function EmployeeEmploymentForm({
  oldDetails = [],
  newDetails = [],
  isMovement = {},
  isLoading = false,
  isModalOpen = false,
  initialValues = {},
  onSubmitModal = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  setMovement = () => { },
  setModalOpen = () => { },
  handleCancel = () => { },
  employeeTypeOptions = [],
  employeeStatusTypeOptions = [],
  employeeOptions = [],
  employmentTypeOptions = [],
  currentWorking = {},
  departmentOptions = [],
  positionOptions = [],
  shiftOptions = [],
  workInLocationOptions = [],
  holidayCalendarOptions = [],
  reasonForSeparationOptions = [],
  bankOptions = [],
  movementGroupOptions = [],
}) {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [form] = useForm()

  // console.log("initialValues", initialValues);
  // console.log("positionOptions", positionOptions);

  // // console.log("isMovement", isMovement);
  // // console.log("isModalOpen", isModalOpen);
  // // console.log("employeeStatusTypeOptions", employeeStatusTypeOptions);
  // console.log("initialValues", currentWorking);

  useEffect(() => {
    console.log("initialValues", initialValues, initialValues.extensionProbationEx, initialValues.extensionProbationEx == 'Y' ? (initialValues?.daysProbationEx - 1) : currentWorking?.dayOfProbation - 1);
    form.setFieldsValue({
      ...initialValue,
      ...initialValues,
      daysProbationEx: initialValues.extensionProbationEx == 'Y' ? (initialValues?.daysProbationEx) : currentWorking?.dayOfProbation,
      bankAccountNo: initialValues?.bankAccountNo ? formatBankAccountNo(initialValues?.bankAccountNo, true) : null,
      supervisorId: [{
        label: initialValues?.supervisor?.length > 0 ? (i18n.language === "en" ? initialValues?.supervisor?.[0]?.nameEn + " " + initialValues?.supervisor?.[0]?.surNameEn : initialValues?.supervisor?.[0]?.name + " " + initialValues?.supervisor?.[0]?.surName) : null,
        title: initialValues?.supervisor?.length > 0 ? (i18n.language === "en" ? initialValues?.supervisor?.[0]?.nameEn + " " + initialValues?.supervisor?.[0]?.surNameEn : initialValues?.supervisor?.[0]?.name + " " + initialValues?.supervisor?.[0]?.surName) : null,
        value: initialValues?.supervisor?.[0]?.id,
        key: initialValues?.supervisor?.[0]?.id,
      }]
    })
  }, [initialValues, form, i18n.language])

  return (
    <>
      <Modal
        title={t("salary.label.save_movement")}
        open={isModalOpen}
        onCancel={handleCancel}
        width="1000px"
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VALUES, ...isMovement, }}
          onSubmit={(values) => {
            const submissionValues = { ...values };

            // submissionValues.newValue.supervisorId =
            //   values?.newValue?.supervisorId?.length > 0
            //     ? values.newValue.supervisorId.map((item) => item.value ?? item)
            //     : null;

            onSubmitModal(submissionValues);

            // console.log("values", values);
            // const submissionValues = {
            //   ...values,
            // };

          }}
        // validationSchema={employeeEmploymentModalSchema}
        >
          {({ values, setFieldValue, getFieldMeta, resetForm }) => (
            <Form>
              <Space direction="vertical" size={6} style={{ width: "100%" }}>
                <Switch
                  name="forceSave"
                  label={t("salary.label.force_save")}
                  size="large"
                  onChange={(value) => setFieldValue("forceSave", value)}
                />
                <Divider />
                <Row gutter={[24, 10]}>
                  {values.forceSave === false && (
                    <>

                      {(values.movementTypeList.length !== 0 ?
                        <Col span={12}>
                          <Select
                            name="movementTypeList"
                            label={t("employeeShift.table.movementType")}
                            placeholder={t("common.pleaseSelect")}
                            size="large"
                            options={movementGroupOptions}
                            mode="multiple"
                            disabled
                          />
                        </Col>
                        : null)}
                      {(values.movementTypeList.length !== 0 ?
                        <Col span={12}>
                          <DatePicker
                            required
                            name="effectiveDate"
                            label={t("employeeShift.table.effectiveDate")}
                            placeholder={t("common.placeholder.ddmmyyyy")}
                            size="large"
                            format={formatDate()}
                            min={dayjs()}

                          />
                        </Col>
                        : <Col span={24}>
                          <DatePicker
                            required
                            name="effectiveDate"
                            label={t("employeeShift.table.effectiveDate")}
                            placeholder={t("common.placeholder.ddmmyyyy")}
                            size="large"
                            format={formatDate()}
                            min={dayjs()}

                          />
                        </Col>)}
                    </>
                  )}
                  <Col span={24}>
                    <Input
                      name="remark"
                      label={t("salary.label.remark")}
                      placeholder={t("salary.label.remark")}
                      size="small"
                      type="textarea"
                    />
                  </Col>
                  <Col span={12}>
                    <EmployeeDetailsCard
                      title={t("salary.label.old_data")}
                      details={oldDetails}
                      comparisonDetails={newDetails}
                    />
                  </Col>
                  <Col span={12}>
                    <EmployeeDetailsCard
                      title={t("salary.label.new_data")}
                      details={newDetails}
                      comparisonDetails={oldDetails}
                    />
                  </Col>
                </Row>
                <div style={{ height: 12 }} />
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <AntButton
                      id="movement_cancelBtn"
                      type="default"
                      onClick={() => {
                        resetForm();
                        setModalOpen(false);
                        setMovement({});
                      }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </AntButton>
                    <AntButton loading={isLoading} disabled={isLoading} type="primary" style={{ backgroundColor: isLoading ? "" : "var(--button-color)" }} htmlType="submit">
                      {t("common.submit").toUpperCase()}
                    </AntButton>
                  </Space>
                </Row>
              </Space>
            </Form>
          )}
        </Formik>
      </Modal>
      <FormAntd
        form={form}
        // initialValues={{ ...initialValue, ...initialValues }}
        validationSchema={employmentInfoSchema}
        onFinish={onSubmit}
      >
        <FormItem shouldUpdate={(prev, curv) => {
          // if (curv['extensionProbation'] == 'Y') {
          //   setdayjs(currentEmployment?.employmentDate, 'YYYY-MM-DD').add(119 + (currentEmployment.extensionProbation == 'Y' ? currentEmployment.daysProbation : 0), 'days')
          // }


          if (prev['employmentDate'] !== curv['employmentDate']) {
            curv['probationDate'] = curv['employmentDate']?.add(Number(curv['daysProbationEx']) + (curv['extensionProbation'] === 'Y' ? Number(curv['daysProbation']) : 0) - 1, 'day')
          }
          if (prev['employmentDate'] !== curv['employmentDate'] && curv['extensionProbation'] === 'Y') {
            curv["probationDate"] = curv['employmentDate']?.add(Number(curv['daysProbationEx']), 'day').add(Number(curv['daysProbation']), 'day')

          }

          return prev['paymentMethod'] !== curv['paymentMethod']
            || prev['extensionProbation'] !== curv['extensionProbation']
            || prev['extensionProbationEx'] !== curv['extensionProbationEx']
            || prev['manpowerType'] !== curv['manpowerType']
            || prev['recordTime'] !== curv['recordTime']
            || prev['isApproveJoin'] !== curv['isApproveJoin']
            || prev['probationDate'] !== curv['probationDate']
            || prev['employeeStatusId'] !== curv['employeeStatusId']
            || prev['supervisorId'] !== curv['supervisorId']
            || prev['employeeStatusCode'] !== curv['employeeStatusCode']
            || prev['employeeTypeId'] !== curv['employeeTypeId']
            || prev['otRequestUnable'] !== curv['otRequestUnable']
        }}>
          {({ getFieldValue, setFieldValue, resetForm }) => {


            return (
              <Layout>
                <Content style={{ marginBottom: "1vh" }}>
                  <Card>
                    <Space style={{ width: "100%" }} size={24} direction="vertical">
                      {/* Employment Information */}
                      <Space size={12} direction="vertical">
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("employment-information.header")}</span>
                        <Row gutter={[24, 16]} >
                          <Col span={12}>
                            <FormSelect
                              required
                              name="employeeStatusId"
                              label={t("employment-information.label.employee-status")}
                              placeholder={t("employment-information.label.employee-status")}
                              size="large"
                              options={employeeStatusTypeOptions}
                              onChange={(v) => {
                                let xx = employeeStatusTypeOptions.filter(item => item?.id === v).map((item) => {
                                  setFieldValue('employeeStatusCode', item?.code)
                                  return item?.code
                                })
                                if (xx.includes("EMPLOYEE_STATUS_TYPE_02")) {
                                  if (!getFieldValue("dateEffective"))
                                    setFieldValue('dateEffective', getFieldValue("probationDate"))
                                }
                              }
                              }
                            />
                          </Col>
                          <Col span={12}>
                            <FormSelect
                              required
                              name="employeeTypeId"
                              label={t("employment-information.label.employee-type")}
                              placeholder={t("employment-information.label.employee-type")}
                              size="large"
                              options={employeeTypeOptions}
                              onChange={(v) => {
                                form.setFields([{ name: 'dateContractExpire', errors: [] }]);
                                form.validateFields(['dateContractExpire']);
                              }}
                            />
                          </Col>
                          {employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_03" && <>
                            <Col span={12}>
                              <FormDatePicker
                                name="dateExpiration"
                                label={t('employment-information.label.date-of-expriation')}
                                placeholder={t('employment-information.label.date-of-expriation')}
                                size="large"
                                format={formatDate()}
                                required={employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_03"}
                              />
                            </Col>
                            <Col span={12}>
                              <FormSelect
                                name="reasonOfSeparation"
                                label={t("master_data.label.reason_for_separationimport")}
                                placeholder={t("master_data.label.reason_for_separationimport")}
                                size="large"
                                options={reasonForSeparationOptions}
                                required
                              />
                            </Col>
                          </>}
                          {
                            employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                              <Col span={12}>
                                {/* <Flex vertical> */}
                                <Row gutter={[0, 20]} justify={"center"}>
                                  <Col span={24}>
                                    <Flex vertical={false} justify="space-between">
                                      {
                                        employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                                          <Checkbox
                                            style={{ top: "0", alignSelf: "center" }}
                                            name="extensionProbation"
                                            checked={getFieldValue("extensionProbation") === "Y"}
                                            onChange={(e) => {
                                              setFieldValue("extensionProbation", e.target.checked ? "Y" : "N")
                                              if (e.target.checked) {
                                                if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("employmentDate") === null) {

                                                  setFieldValue("daysProbation", dayjs().add(getFieldValue('daysProbationEx'), 'day'))
                                                } else {
                                                  // setFieldValue("probationDate", dayjs().add(currentWorking?.dayOfProbation ? parseInt(currentWorking?.dayOfProbation) - 1 : 118, 'day'))
                                                  setFieldValue("probationDate", dayjs(getFieldValue("probationDate")).add(getFieldValue("daysProbation"), 'day'))
                                                }

                                              } else {
                                                if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("employmentDate") === null) {
                                                  setFieldValue("daysProbation", dayjs().add(getFieldValue('daysProbationEx') - 1, 'day'))
                                                } else {
                                                  setFieldValue("probationDate", dayjs(getFieldValue("employmentDate")).add(getFieldValue('daysProbationEx') - 1, 'day'))
                                                  setFieldValue("daysProbation", 0)
                                                }

                                              }
                                            }
                                            }
                                            disabled={employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code !== "EMPLOYEE_STATUS_TYPE_01"}
                                          >
                                            {t("employment-information.label.extension-probation")}
                                          </Checkbox> : null
                                      }
                                      {
                                        getFieldValue("extensionProbation") === "Y" && employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                                          <FormInputNumber
                                            textAlign="right"
                                            name="daysProbation"
                                            label={""}
                                            placeholder={t("common.pleaseChoose")}
                                            controls={false}
                                            size="large"
                                            // suffix={t("unit.days")}
                                            precision={0}
                                            onChange={(v) => {
                                              if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("r") === null) {
                                                setFieldValue("probationDate", dayjs().add(getFieldValue('daysProbationEx') - 1, 'day'))
                                              } else {
                                                setFieldValue("probationDate", dayjs(getFieldValue("employmentDate")).add(getFieldValue("daysProbationEx"), 'day').add(v - 1, 'day'))
                                              }
                                            }}
                                          /> : null
                                      }
                                    </Flex>
                                  </Col>
                                  <Col span={24}>
                                    <Flex vertical={false} justify="space-between">
                                      {
                                        employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                                          <Checkbox
                                            style={{ top: "0", alignSelf: "center" }}
                                            name="extensionProbationEx"
                                            checked={getFieldValue("extensionProbationEx") === "Y"}
                                            onChange={(e) => {
                                              setFieldValue("extensionProbationEx", e.target.checked ? "Y" : "N")
                                              if (e.target.checked) {
                                                if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("employmentDate") === null) {
                                                  setFieldValue("daysProbationEx", currentWorking?.dayOfProbation)
                                                } else {
                                                  // setFieldValue("probationDate", dayjs().add(currentWorking?.dayOfProbation ? parseInt(currentWorking?.dayOfProbation) - 1 : 118, 'day'))
                                                  setFieldValue("probationDate", dayjs(getFieldValue("employmentDate")).add(getFieldValue("daysProbation"), 'day').add(getFieldValue('daysProbationEx') - 1, 'day'))
                                                }

                                              } else {
                                                if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("employmentDate") === null) {
                                                  setFieldValue("daysProbationEx", currentWorking?.dayOfProbation)
                                                } else {
                                                  setFieldValue("probationDate", dayjs(getFieldValue("employmentDate")).add(currentWorking?.dayOfProbation - 1, 'day').add(getFieldValue('daysProbation') ?? 0, 'day'))
                                                  setFieldValue("daysProbationEx", currentWorking?.dayOfProbation)
                                                }
                                              }
                                            }
                                            }
                                            disabled={employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code !== "EMPLOYEE_STATUS_TYPE_01"}
                                          >
                                            {t("employment-information.label.extension-probation-ex")}
                                          </Checkbox> : null
                                      }
                                      {
                                        getFieldValue("extensionProbationEx") === "Y" && employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                                          <FormInputNumber
                                            textAlign="right"
                                            name="daysProbationEx"
                                            label={""}
                                            placeholder={t("common.pleaseChoose")}
                                            controls={false}
                                            size="large"
                                            // suffix={t("unit.days")}
                                            precision={0}
                                            onChange={(v) => {
                                              if (getFieldValue("probationDate") === "Invalid Date" || getFieldValue("employmentDate") === null) {
                                                setFieldValue("probationDate", dayjs().add(getFieldValue("dayProbation") ?? 0 ? parseInt(getFieldValue("dayProbation") ?? 0) - 1 : v - 1, 'day'))
                                              } else {
                                                console.log("ssss", getFieldValue("employmentDate"), getFieldValue("dayProbation") ?? 0);
                                                setFieldValue("probationDate", dayjs(getFieldValue("employmentDate")).add(getFieldValue("dayProbation") ?? 0, 'day').add(v - 1, 'day'))
                                              }
                                            }}
                                          /> : null
                                      }
                                    </Flex>
                                  </Col>
                                </Row>
                              </Col> : null
                          }

                          {
                            employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_01" ?
                              <Col span={12} /> : null
                          }
                          <Col span={12}>
                            <FormDatePicker
                              required
                              name="employmentDate"
                              label={t("employee.label.employment-date")}
                              placeholder={t("common.placeholder.ddmmyyyy")}
                              size="large"
                              format={formatDate()}
                              onChange={(v) => {
                                // if (getFieldValue("extensionProbation") === "Y") {
                                //   setFieldValue("probationDate", dayjs(v).add(getFieldValue("daysProbation"), 'day'))
                                // } else {
                                //   setFieldValue("probationDate", dayjs(v).add(currentWorking?.dayOfProbation ? parseInt(currentWorking?.dayOfProbation) - 1 : 118, 'day'))
                                // }
                              }}
                            />
                          </Col>
                          <Col span={12}>
                            <FormDatePicker
                              name="probationDate"
                              label={t("employee.label.probation_date")}
                              placeholder={t("common.placeholder.ddmmyyyy")}
                              size="large"
                              format={formatDate()}
                              disabled
                            />
                          </Col>
                          {employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_02" && <>
                            <Col span={12}>
                              <FormDatePicker
                                name="dateEffective"
                                label={t('employment-information.label.date-of-effective')}
                                placeholder={t('employment-information.label.date-of-effective')}
                                size="large"
                                format={formatDate()}
                              // required={employeeStatusTypeOptions.find((item) => item?.id === getFieldValue("employeeStatusId"))?.code === "EMPLOYEE_STATUS_TYPE_02"}
                              />
                            </Col>
                            <Col span={12}>
                            </Col>
                          </>}
                          <Col span={12}>
                            <FormDatePicker
                              name="dateContractExpire"
                              label={t("employment-information.label.date-contract-expire")}
                              placeholder={t("employment-information.label.date-contract-expire")}
                              size="large"
                              format={formatDate()}
                              required={employeeTypeOptions.find((item) => item?.id === getFieldValue("employeeTypeId"))?.requireContractExpiryDate === "Y"}
                              allowClear
                            />
                          </Col>
                          <Col span={12}>
                            <Flex vertical gap={8}>
                              <FormSelect
                                name="supervisorId"
                                label={t("employment-information.label.report-to")}
                                placeholder={t("employment-information.label.report-to")}
                                size="large"
                                options={employeeOptions}
                                onChange={(e) => {
                                  setFieldValue('supervisorId', [e])
                                }}
                                maxCount="1"
                                allowClear={true}
                              />
                            </Flex>
                          </Col>
                          <Col span={12}>
                            <FormSelect
                              name="holidayCalendarId"
                              label={t("employment-information.label.holiday-calendar")}
                              placeholder={t("employment-information.label.holiday-calendar")}
                              size="large"
                              options={holidayCalendarOptions}
                            />
                          </Col>
                          <Col span={12}>
                            <FormInput
                              name="driverNo"
                              label={t("employment-information.label.driver-no")}
                              placeholder={t("employment-information.label.driver-no")}
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            {/* <FormInput
                              name="driverNo"
                              label={t("employment-information.label.driver-no")}
                              placeholder={t("employment-information.label.driver-no")}
                              size="large"
                            /> */}
                          </Col>
                          <Col span={12}>
                            <FormDatePicker
                              name="driverExpire"
                              label={t("employment-information.label.driver-no-expire")}
                              placeholder={t("employment-information.label.driver-no-expire")}
                              size="large"
                              format={formatDate()}
                              allowClear
                            />
                          </Col>
                          {/* <Col span={12}>
                            <Row gutter={[24, 16]}>
                              <Col span={24}>
                                <label style={{ fontSize: '16px' }}>{t("employment-information.label.manpower-type")}</label>
                                <label style={{ color: 'red', fontWeight: 'bold' }}>*</label>
                              </Col>
                              <Col span={24}>
                                <Radio.Group
                                  required
                                  optionType="button"
                                  buttonStyle="solid"
                                  name="manpowerType"
                                  value={getFieldValue("manpowerType")}
                                  // defaultValue={getFieldValue("manpowerType")}
                                  label={t("employment-information.label.manpower-type")}
                                  onChange={(e) => {
                                    setFieldValue("manpowerType", e.target.value)
                                  }}
                                  options={[
                                    {
                                      label: t(
                                        "employment-information.label.manpower.type.new"
                                      ),
                                      value: "NEW",
                                    },
                                    {
                                      label: t(
                                        "employment-information.label.manpower.type.replace"
                                      ),
                                      value: "REPLACE",
                                    },
                                  ]}
                                />
                              </Col>
                            </Row>
                          </Col> */}
                          <Col span={12}>
                            <Row gutter={[24, 16]}>
                              <Col span={24}>
                                <label style={{ fontSize: '16px' }}>{t("employment-information.label.record-time")}</label>
                                <label style={{ color: 'red', fontWeight: 'bold' }}>*</label>
                              </Col>
                              <Col span={24}>
                                <ConfigProvider
                                  theme={{
                                    components: {
                                      Radio: {
                                        buttonSolidCheckedBg: "var(--button-color)"
                                      },
                                    },
                                  }}
                                >
                                  <Radio.Group
                                    required
                                    optionType="button"
                                    buttonStyle="solid"
                                    name="recordTime"
                                    value={getFieldValue("recordTime")}
                                    // defaultValue={getFieldValue("recordTime")}
                                    label={t("employment-information.label.record-time")}
                                    onChange={(e) => {
                                      setFieldValue("recordTime", e.target.value)
                                    }}
                                    options={[
                                      {
                                        label: t("Record"),
                                        value: "RECORD",
                                      },
                                      {
                                        label: t("dont-record"),
                                        value: "DONTRECORD",
                                      },
                                    ]}
                                  />
                                </ConfigProvider>
                              </Col>
                            </Row>
                          </Col>

                          <Col span={12}>
                            <Row gutter={[24, 16]}>
                              <Col span={24}>
                                <label style={{ fontSize: '16px' }}>{t("employment-information.label.ot_request")}</label>
                                <label style={{ color: 'red', fontWeight: 'bold' }}>*</label>
                              </Col>
                              <Col span={24}>
                                <ConfigProvider
                                  theme={{
                                    components: {
                                      Radio: {
                                        buttonSolidCheckedBg: "var(--button-color)"
                                      },
                                    },
                                  }}
                                >
                                  <Radio.Group
                                    required
                                    optionType="button"
                                    buttonStyle="solid"
                                    name="otRequestUnable"
                                    value={getFieldValue("otRequestUnable")}
                                    label={t("employment-information.label.ot_request")}
                                    onChange={(e) => {
                                      setFieldValue("otRequestUnable", e.target.value)
                                    }}
                                    options={[
                                      {
                                        label: t("allow"),
                                        value: "Y",
                                      },
                                      {
                                        label: t("not-allowed"),
                                        value: "N",
                                      },
                                    ]}
                                  />
                                </ConfigProvider>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Space>
                      <Divider className={styles.customDivider} />

                      {/* Corporate Information */}
                      <Space size={12} direction="vertical">
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("corporate-information")}</span>
                        <Row gutter={[24, 16]}>
                          <Col span={12}>
                            <FormInput
                              required
                              name="companyName"
                              label={t("company_profile.label.company_name")}
                              placeholder={t("common.pleaseSelect")}
                              size="large"
                              disabled
                            />
                          </Col>
                          <Col span={12}>
                            <FormInput
                              required
                              name="employeeNo"
                              label={t("employee.label.employee_no")}
                              placeholder={t("employee.label.employee_no")}
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <FormSelect
                              required
                              tree={true}
                              name="departmentId"
                              label={t("employee.label.department")}
                              placeholder={t("common.pleaseSelect")}
                              size="large"
                              options={departmentOptions}
                              onChange={(e) => {
                                // console.log("departmentOptions", e);
                              }}
                            />
                          </Col>
                          <Col span={12}>
                            {/* <TreeSelectDropdown
                            ></TreeSelectDropdown> */}
                            <FormSelect
                              tree={true}
                              required
                              name="positionId"
                              label={t("employee.label.position")}
                              placeholder={t("common.pleaseSelect")}
                              size="large"
                              options={positionOptions}
                              onChange={(e) => {
                                // console.log("positionOptions", e);
                              }}
                            />
                          </Col>
                          <Col span={12}>
                            <FormSelect
                              name="branchId"
                              required
                              label={t("employee.label.branch")}
                              placeholder={t("common.pleaseSelect")}
                              size="large"
                              // mode="multiple"
                              options={workInLocationOptions}
                            />
                          </Col>
                          <Col span={12}>
                            <FormSelect
                              required
                              name="shiftId"
                              label={t("employee.label.shift")}
                              placeholder={t("common.pleaseSelect")}
                              size="large"
                              options={shiftOptions}
                            // disabled
                            />
                          </Col>
                        </Row>
                      </Space>
                      <Divider className={styles.customDivider} />

                      {/* Salary Information */}
                      <Flex size={12} vertical>
                        <Flex>
                          <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("employee.salary-information")}</span>
                        </Flex>
                        <Row gutter={[24, 16]}>
                          <Col span={12}>
                            <Row gutter={[24, 16]}>
                              <Col span={24}>
                                <label style={{ fontSize: '16px' }}>
                                  {t("employment-information.label.employment-type")}
                                </label><label style={{ color: 'red', fontWeight: 'bold' }}>*</label>
                              </Col>
                              <Col span={24}>
                                <FormSelect
                                  required
                                  name="employmentTypeId"
                                  // label={t("employment-information.label.employment-type")}
                                  placeholder={t("common.pleaseSelect")}
                                  size="large"
                                  options={employmentTypeOptions}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col span={12} style={{ alignSelf: "end" }}>
                            <Flex>
                              <label style={{ fontSize: '16px' }}>
                                {t("payment-information.label.payment-method")}
                              </label><label style={{ color: 'red' }}>*</label>
                            </Flex>
                            <FormItem
                              name="paymentMethod"
                              rules={[
                                {
                                  required: true,
                                  message: t("payment-information.label.payment-method-required"), // ข้อความแจ้งเตือน
                                },
                              ]}
                            >
                              <ConfigProvider
                                theme={{
                                  components: {
                                    Radio: {
                                      buttonSolidCheckedBg: "var(--button-color)"
                                    },
                                  },
                                }}
                              >
                                <Radio.Group
                                  optionType="button"
                                  size="large"
                                  buttonStyle="solid"
                                  name="paymentMethod"
                                  value={getFieldValue("paymentMethod")}
                                  label={t("payment-information.label.payment-method")}
                                  onChange={(e) => {
                                    setFieldValue("paymentMethod", e.target.value);
                                  }}
                                  options={[
                                    {
                                      label: t("employee.salary.label.cash"),
                                      value: "CASH",
                                    },
                                    {
                                      label: t("employee.salary.label.bank"),
                                      value: "BANK",
                                    },
                                    {
                                      label: t("employee.salary.label.PromptPay"),
                                      value: "PROMPTPAY",
                                    },
                                  ]}
                                />
                              </ConfigProvider>
                            </FormItem>
                          </Col>

                          {getFieldValue("paymentMethod") === "BANK" && (
                            <>
                              <Col span={12}>
                                <FormSelect
                                  name="bankAccountId"
                                  label={t("employee.salary.label.bank")}
                                  placeholder={t("common.pleaseSelect")}
                                  size="large"
                                  options={bankOptions}
                                  required />
                              </Col>
                              <Col span={12}>
                                <FormInput
                                  name="bankAccountNo"
                                  label={t("employee.salary.label.bank_account_no")}
                                  placeholder={t("employee.salary.label.bank_account_no")}
                                  size="large"
                                  required
                                  onChange={(value) => {
                                    value = value.replace(/\D/g, ''); // Assuming `value` is now directly the input value
                                    value = value.slice(0, 3) + (value.length > 3 ? '-' : '') +
                                      value.slice(3, 6) + (value.length > 6 ? '-' : '') +
                                      value.slice(6, 17);
                                    setFieldValue("bankAccountNo", value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (!(e.ctrlKey && e.key.match("(c|x|v|a)"))) {
                                      if (e.shiftKey || !(e.code.match("^(Digit|Backspace|Arrow|Numpad|Delete)"))) {
                                        e.preventDefault();
                                      }
                                    }
                                  }}
                                />
                              </Col>
                            </>
                          )}
                          {getFieldValue("paymentMethod") === "PROMPTPAY" && (
                            <>
                              <Col span={12}>
                                <FormInput
                                  name="promptpayNo"
                                  label={t("employee.salary.label.promptpayNo")}
                                  placeholder={t("employee.salary.label.promptpayNo")}
                                  size="large"
                                  required
                                  onChange={(value) => {
                                    setFieldValue("promptpayNo", value);
                                  }}
                                />
                              </Col>
                            </>
                          )}
                        </Row>
                      </Flex>
                    </Space>
                  </Card>
                </Content>
                <Footer
                  style={{
                    zIndex: 999,
                    bottom: 2,
                    position: "sticky",
                    backgroundColor: "white",
                    height: "max-content",
                    placeContent: "center"
                  }}
                >
                  <Row justify="end" style={{ gap: "12px" }}>
                    <Button type="default" onClick={onCancel}
                      style={{ width: "80px", height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit" type="primary"
                      // disabled={!getFieldValue("paymentMethod")}
                      style={{ width: "80px", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                    >
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Row>
                </Footer>
              </Layout>
            );
          }}
        </FormItem>
      </FormAntd >
    </>
  );
}

export default EmployeeEmploymentForm;